import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Calendar, ExternalLink } from "lucide-react";

const NewsAndPressCarousel = () => {
  const navigate = useNavigate();

  const newsItems = [
    {
      id: "0",
      type: "news",
      title: "Brassbell Hospitality Group Launches \"Fanaya Hotel\" in Jeddah, Introducing a New Art-Driven Lifestyle Destination in Saudi Arabia",
      excerpt: "Brassbell officially enters the Saudi Arabian market with Fanaya Hotel in Jeddah, marking a significant milestone in the company's expansion strategy aligned with Vision 2030.",
      date: "2025-11-18",
      image: "https://invest-gate.me/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-18-at-11.06.30_6d4a74ec-750x500.jpg",
      url: "https://invest-gate.me/news/brassbell-hospitality-group-launches-fanaya-hotel-in-jeddah-introducing-a-new-art-driven-lifestyle-destination-in-saudi-arabia/"
    },
    {
      id: "0b",
      type: "news",
      title: "Egypt's Brassbell Hospitality Group Sets Foot in Saudi with SAR 120 mn Fanaya Hotel in Jeddah",
      excerpt: "Fanaya features 51 suites that combine local heritage with contemporary design, all built to international standards with a SAR 120 million investment.",
      date: "2025-11-18",
      image: "https://ent.news/2025/11/1453.jpg",
      url: "https://enterprise.news/ksa/en/news/story/2152c45b-69f8-4a80-a7ae-9c6be2293f47/egypt%e2%80%99s-brassbell-hospitality-group-sets-foot-in-saudi-with-sar-120-mn-fanaya-hotel-in-jeddah"
    },
    {
      id: "0c",
      type: "news",
      title: "Brassbell Hospitality Group Debuts Fanaya Hotel in Jeddah",
      excerpt: "Brassbell launches its Fanaya Hotel in Jeddah as Saudi hospitality shifts toward design-led and culturally driven destinations, with USD 40 million investment.",
      date: "2025-11-18",
      image: "https://waya.media/wp-content/uploads/sites/3/2025/11/Brassbell-Hospitality-Group-Expands-into-Saudi-Arabia-with-Launch-of-Fanaya-Hotel-in-Jeddah.png",
      url: "https://waya.media/brassbell-hospitality-group-debuts-fanaya-hotel-in-jeddah/"
    },
    {
      id: "1",
      type: "news",
      title: "Brassbell Hospitality Group and Belmazad Sign a Strategic Partnership to Transform Auctioned Real Estate into Hospitality Investments",
      excerpt: "Egypt's leading serviced apartment operator partners with the country's premier digital auction marketplace to convert underutilized real estate assets into high-value hospitality investments.",
      date: "2025-09-14",
      image: "https://invest-gate.me/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-14-at-11.44.07-AM-750x500.jpeg",
      url: "https://invest-gate.me/news/brassbell-hospitality-group-and-belmazad-sign-a-strategic-partnership-to-transform-auctioned-real-estate-into-hospitality-investments/"
    },
    {
      id: "2",
      type: "news",
      title: "Brassbell-Belmazad Partner to Transform Auctioned Real Estate into Hospitality Assets",
      excerpt: "Strategic partnership between Brassbell Hospitality Group and Belmazad creates innovative framework to convert auction properties into ready-to-operate hospitality investments.",
      date: "2025-09-14",
      image: "https://invest-gate.me/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-14-at-11.44.07-AM-750x500.jpeg",
      url: "https://www.dailynewsegypt.com/2025/09/14/brassbell-belmazad-partner-to-transform-auctioned-real-estate-into-hospitality-assets/"
    },
    {
      id: "3",
      type: "news",
      title: "Tatweer Misr Launches Its First Hospitality Brand, \"Bay House,\" in Strategic Collaboration with Brassbell Hospitality Group",
      excerpt: "New hospitality brand Bay House launched in D-Bay & Fouka Bay to deliver premium integrated living experiences across Egypt's North Coast.",
      date: "2025-08-03",
      image: "/lovable-uploads/bay-house-tatweer-misr.jpg",
      url: "https://invest-gate.me/news/tatweer-misr-launches-its-first-hospitality-brand-bay-house-in-strategic-collaboration-with-brassbell-hospitality-group/"
    },
    {
      id: "4",
      type: "press",
      title: "Brassbell Hospitality Group and Tatweer Misr Partnership Announcement",
      excerpt: "Strategic partnership ceremony featuring key executives from both companies, announcing the launch of Bay House hospitality brand.",
      date: "2025-08-03",
      image: "/lovable-uploads/6d37aa27-9811-4a76-9592-3e412b5e970c.png"
    },
    {
      id: "5",
      type: "news",
      title: "Tatweer Misr launches first hospitality brand 'Bay House' in partnership with Brassbell",
      excerpt: "Strategic partnership brings premium hospitality services to D-Bay and Fouka Bay on Egypt's North Coast.",
      date: "2025-08-03",
      image: "/lovable-uploads/bay-house-daily-news-egypt.jpg",
      url: "https://www.dailynewsegypt.com/2025/08/03/tatweer-misr-launches-first-hospitality-brand-bay-house-in-partnership-with-brassbell/"
    },
    {
      id: "6",
      type: "news",
      title: "Tatweer Misr launches first hospitality brand 'Bay House' in partnership with Brassbell",
      excerpt: "Egyptian real estate developer announces dedicated hospitality brand debut in D-Bay and Fouka Bay coastal destinations.",
      date: "2025-08-04",
      image: "/lovable-uploads/bay-house-hotel-report.jpg",
      url: "https://hotel.report/novosti/tatweer-misr-launches-first-hospitality-brand-bay-house-in-partnership-with-brassbell"
    }
  ];

  return (
    <section className="py-8 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-8 lg:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-light text-foreground mb-2 md:mb-4">
            Latest News & Press
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto text-base md:text-lg">
            Stay updated with our latest developments, partnerships, and industry recognition
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full max-w-6xl mx-auto"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {newsItems.map((item, index) => (
              <CarouselItem key={index} className="pl-2 md:pl-4 basis-[280px] md:basis-1/2 lg:basis-1/3">
                <div 
                  className="bg-card rounded-lg overflow-hidden shadow-sm border h-full cursor-pointer transition-all duration-300 hover:shadow-lg hover:scale-[1.02]"
                  onClick={() => {
                    if (item.url) {
                      window.open(item.url, '_blank', 'noopener,noreferrer');
                    } else {
                      navigate('/news-press');
                    }
                  }}
                >
                  <div className="aspect-video bg-muted">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      width="371"
                      height="209"
                    />
                  </div>
                  <div className="p-4 md:p-6">
                    <div className="flex items-center gap-2 mb-2 md:mb-3">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        item.type === 'news' 
                          ? 'bg-primary/10 text-primary' 
                          : 'bg-secondary/10 text-secondary-foreground'
                      }`}>
                        {item.type === 'news' ? 'News' : 'Press'}
                      </span>
                      <div className="flex items-center text-xs text-muted-foreground">
                        <Calendar className="h-3 w-3 mr-1" />
                        {new Date(item.date).toLocaleDateString()}
                      </div>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-card-foreground mb-2 line-clamp-2">
                      {item.title}
                    </h3>
                    <p className="text-muted-foreground text-sm line-clamp-3">
                      {item.excerpt}
                    </p>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="-left-4 md:-left-6" />
          <CarouselNext className="-right-4 md:-right-6" />
        </Carousel>

        <div className="text-center mt-6 md:mt-8 lg:mt-12">
          <Button
            onClick={() => navigate('/news-press')}
            size="lg"
            className="inline-flex items-center gap-2 text-sm md:text-base"
          >
            View All News & Press
            <ExternalLink className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NewsAndPressCarousel;